<template>
    <Modal>
        <ModalCard
            :active-validate="false"
            :headerTitle="$t('document.reglementaire.modal.header')"
            :is-pop-up-table="true"
            :noPaddingTop="false"
            :withoutBotNav="true"
            class="modal-choix-site"
            @cancel="cancel"
        >
            <CheckBox
                :checked="typesSelectionnees.length === typesDocuments.length"
                :label="$t('typeSelection.selectionner.tout')"
                :partiel="typesSelectionnees.length > 0 && typesSelectionnees.length !== typesDocuments.length"
                @clickCheck="addAllTypes"
            />

            <div :aria-label="$t('document.reglementaire.modal.header')" class="wrap" role="group">
                <div
                    v-for="document in typesDocuments"
                    :key="document.id"
                    class="margin-10px"
                    @click="addType(document)"
                >
                    <CheckBox
                        :checked="typesSelectionnees.some(type => type.code === document.code)"
                        :label="getLibelleDocuement(document)"
                    />
                </div>
            </div>

            <div class="button-modal-container">
                <ButtonBlue
                    :disabled="typesSelectionnees.length === 0"
                    :onClick="valider"
                    :text="$t('app.bottom.navigation.button.confirm')"
                    class="button-confirm btn"
                    name="confirm"
                />
            </div>
        </ModalCard>
    </Modal>
</template>

<script lang="ts">
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import ButtonBlue from '@/components/ui-components/ButtonBlue.vue';
import { defineComponent, PropType } from 'vue';
import {
    isBffDocumentType,
    TypeDocumentReglementaire,
} from '@/models/TypeDocumentReglementaire';
import CheckBox from '@/components/ui-components/CheckBox.vue';

export default defineComponent({
    name: 'ModalChoixTypeDocuments',
    data(): {
        isAllTypes: boolean;
        typesSelectionnees: TypeDocumentReglementaire[];
    } {
        return {
            isAllTypes: false,
            typesSelectionnees: [],
        };
    },
    components: { CheckBox, Modal, ModalCard, ButtonBlue },
    props: {
        selectedTypes: { type: Array as PropType<TypeDocumentReglementaire[]>, required: true },
        typesDocuments: { type: Array as PropType<TypeDocumentReglementaire[]>, required: true },
    },
    beforeMount() {
        this.typesSelectionnees = [...this.selectedTypes];
    },
    methods: {
        cancel(): void {
            this.$emit('cancel');
        },
        valider(): void {
            this.$emit('valider', this.typesSelectionnees);
        },
        addType(type: TypeDocumentReglementaire): void {
            if (isBffDocumentType(type)) {
                this.typesSelectionnees = [type];
            } else {
                const databaseTypes = this.typesSelectionnees.filter(t => !isBffDocumentType(t));
                const isSelected = databaseTypes.some(t => t.code === type.code);
                this.typesSelectionnees = isSelected
                    ? databaseTypes.filter(t => t.code !== type.code)
                    : [...databaseTypes, type];
            }
        },
        addAllTypes(): void {
            if (this.typesSelectionnees.length > 0) {
                this.typesSelectionnees = [];
            } else {
                this.typesSelectionnees = this.typesDocuments.filter(type => !isBffDocumentType(type));
            }
        },
        getLibelleDocuement(typeDocument: TypeDocumentReglementaire) {
            if (typeDocument.id !== null && typeDocument.id < 9) {
                return this.$t(`document.type.${typeDocument.id}`);
            } else {
                return typeDocument.libelle;
            }
        },
    },
});
</script>

<style scoped>
:deep(.card-content-container) {
    overflow: hidden;
}
.button-confirm {
    right: 16px;
}
.btn {
    width: 90px;
    border-radius: 5px;
    cursor: pointer;
    height: 40px;
    margin: 5px;
}
.button-modal-container {
    text-align: right;
}
.radio-container {
    cursor: pointer;
    padding: 8px 24px 8px 24px;
    width: 50%;
}
@media (max-height: 925px) {
    .radio-container {
        padding: 0 24px 0 24px;
    }
}
@media (max-height: 775px) {
    :deep(.card-content-container) {
        padding: 0;
    }
    .select-site-container {
        height: 52vh;
    }
}
@media (max-height: 675px) {
    .modal-choix-site {
        max-height: 80%;
    }
    :deep(.card-content-container) {
        max-height: 65vh;
    }
    .modal-choix-site {
        width: 70vw;
    }
}
@media (min-height: 676px) {
    .modal-choix-site {
        width: 50vw;
    }
}
@media (min-height: 776px) {
    .select-site-container {
        height: 39vh;
    }
}
.flex {
    display: flex;
}
.span-container {
    vertical-align: super;
}
:deep(.card-content-container) {
    max-height: 70vh;
}
:deep(.select-all-container) {
    display: flex;
}
:deep(.margin--10px) {
    margin-top: -10px;
}
:deep(.recherche-container) {
    display: flex;
}
:deep(.first-container) {
    width: 50%;
}
:deep(.search-bar) {
    width: 100%;
    margin-top: -5px;
}
:deep(.title) {
    width: 50%;
}
.wrap {
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
    max-height: 60vh;
}
.margin-10px {
    width: 40%;
    box-sizing: border-box;
}
@media (min-height: 676px) {
    .modal-choix-site {
        width: 56vw;
    }
}
</style>
